import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/learnMore.css";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { motion } from "framer-motion"; // Import Framer Motion

const LearnMore = () => {
  const navigate = useNavigate();
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="learn-more-container">
      {/* Animated Back Button */}
      <motion.div transition={{ duration: 0.3 }}>
        <IoMdArrowRoundBack
          className="back-icon"
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            top: "20px",
            left: "30px",
            fontSize: "2rem",
            color: "#B3FF00",
            cursor: "pointer",
          }}
        />
      </motion.div>

      {/* Animated Horizontal Line */}
      <motion.hr
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      />

      {/* Animated Content */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { staggerChildren: 0.3 },
          },
        }}
      >
        {/* Title */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          "Innovation in Motion, Solutions in Action."
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          At commceed, we don’t just deliver products; we deliver
          forward-thinking solutions that power your network, elevate your
          infrastructure, and keep you ahead of the curve. With every cable,
          every connection, and every system we provide, we turn complex
          challenges into seamless experiences, transforming your ideas into
          reality with precision and expertise.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          At commceed, we believe that life should flow effortlessly every hour,
          every day, across the globe. Our team is dedicated to building a world
          you can rely on. As a leading provider of global supply chain
          solutions, we transform inspiration into innovation. Through our
          unique expertise, we create solutions that redefine the way you do
          business.
        </motion.p>

        {/* Our Mission */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Our Mission
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          We build, connect, power, and protect the world. For those who drive
          progress and productivity, commceed is here to meet your challenges
          with the right expertise, delivering the innovation and solutions that
          keep the world advancing.
        </motion.p>

        {/* Our Customer Promise */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Our Customer Promise
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Innovation in motion. commceed is committed to delivering the
          problem-solving and innovative thinking you rely on to address your
          most critical supply chain challenges. We work relentlessly as your
          trusted partner, ensuring exceptional service and operational
          excellence.
        </motion.p>

        {/* Work at Commceed */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Work at commceed
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Choosing a career at commceed means adding more of yourself to your
          work. As you focus on growth, we focus on you. You deserve a place
          where your skills and passions are embraced. At commceed, you define
          your path. We provide the environment where you can be authentic, make
          a difference, and reach your full potential.
        </motion.p>

        {/* Inclusion and Diversity */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Inclusion and Diversity
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          At commceed, our people are our most valuable asset. We’re committed
          to creating an environment where each team member’s unique experiences
          and contributions are valued and celebrated.
        </motion.p>

        {/* Investor Relations */}
        <motion.h2
          className="learnMoreTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          Investor Relations
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
        >
          We’re investing in digital transformation to shape the future and lead
          our industry forward. With favorable market trends, commceed’s
          opportunity to grow, increase profitability, and create lasting value
          has never been greater.
        </motion.p>
      </motion.div>
    </div>
  );
};

export default LearnMore;
